<template>
  <div>
    <div class="rank-nav rank-teacher-nav">
      <h3>教师排行榜</h3>
      <span @click="toRankTeacher">查看更多 &gt;</span>
    </div>
    <div class="con-list f-clearfix">
      <ul class="rank-body rank-teacher f-clearfix">
        <li
          v-for="(item, index) in tableList"
          :key="index"
          @click="toDetail(item)"
        >
          <div v-if="index > 2" class="item-index">
            <div>{{ index + 1 }}</div>
          </div>
          <div v-else class="item-index"></div>
          <div class="item-img">
            <img v-img.lazy="getUrl(item.avatar)" :alt="item.realName" />
          </div>
          <div class="item-content">
            <h3>{{ item.realName }}</h3>
            <div class="item-title">
              <p>{{ item.schoolName }}</p>
            </div>
            <div class="item-count">
              <span class="item-school">课程：{{ item.courseCount || 0 }}</span>
              <span class="item-edu"> {{ item.studentCount || 0 }}人选课 </span>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableList: [],
      imgUrl: this.$setting.fdsDomain,
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getUrl(url) {
      if (!url) {
        return url;
      }
      if (url.startsWith("http")) {
        return url;
      } else {
        return this.imgUrl + url;
      }
    },
    toDetail(val) {
      window.open(`${val.linkUrl}`);
    },
    toRankTeacher() {
      window.open(`/teacher`);
    },
    getList() {
      this.$http
        .get("api/web/teacher/webRank")
        .then((res) => {
          let item = res.data;
          for (let i = 0; i < item.length; i++) {
            if (i < 5) {
              if (item[i].linkUrl != "" && item[i].linkUrl != null) {
                item[i].linkUrl = item[i].linkUrl.replace("/spoc/", "/");
              }
              this.tableList.push(item[i]);
            }
          }
        })
        .catch((msg) => {
          console.log(msg);
        });
    },
  },
};
</script>
<style lang="scss">
</style>


